import { Phone } from "lucide-react";
import { SITE } from "@/siteConfig";
import { useQuote } from "./QuoteModal";
import { useContent } from "@/content/ContentContext";

const BASE =
  "inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-7 py-3 text-sm font-bold tracking-[0.08em] transition-[color,background-color,border-color,transform] duration-300 hover:-translate-y-0.5 active:translate-y-0";

export function QuoteButton({ label = "GET A QUOTE", service, variant = "dark", testid = "quote-button", className = "", offer = false }) {
  const { openQuote } = useQuote();
  const styles =
    variant === "dark"
      ? "bg-ember text-charcoal hover:bg-ember-dark hover:text-white"
      : "bg-ember text-charcoal hover:bg-ember-dark hover:text-white";
  return (
    <button type="button" data-testid={testid} onClick={() => openQuote(service, offer)} className={`${BASE} ${styles} ${className}`}>
      {label}
    </button>
  );
}

export function CallButton({ variant = "outline", className = "", label = "CALL MODIFY", testid = "call-modify-button" }) {
  const { get } = useContent();
  const styles =
    variant === "outline"
      ? "border-2 border-charcoal text-charcoal hover:bg-charcoal hover:text-white"
      : variant === "solid-light"
        ? "bg-white text-charcoal hover:bg-sand"
        : "border-2 border-white/40 text-white hover:bg-white hover:text-charcoal";
  return (
    <a href={get("site_phone_href", SITE.phoneHref)} data-testid={testid} className={`${BASE} ${styles} ${className}`}>
      <Phone className="h-4 w-4" aria-hidden="true" />
      {label}
    </a>
  );
}
